import testingCommisionaAtionTypes from "../../actions/TestingCommission/TCActionTypes";

const initialState = {
  processingpercentage:'',
  isVendorLogin:false,
  isDateSetInEditMode: false,
  isEditMode: false,
  isViewMode: false,
  manufacturer: "",
  assetdesc: "",
  chassisno: "",
  class: "",
  departmentid: "",
  facilityid: "",
  financeassetno: "",
  id: "",
  isdefibrillationproof: "",
  istestpassed: "",
  lifespan: "",
  locationid: "",
  model: "",
  powercord: "",
  purchaseprice: "",
  referenceno: "",
  registerno: "",
  remarks: "",
  serialno: "",
  service: "",
  testingcommissioncompletedate: "",
  testingcommissionno: "",
  testingcommissionstartdate: "",
  type: "",
  typedescription: "",
  typecodeid: "",
  vendorid: "",
  isunderwarranty: "",
  warrentyexpirydate: "",
  warrentystartdate: "",
  //COMMON
  createdby: "",
  createddate: "",
  deletedby: "",
  deleteddate: "",
  isdeleted: "",
  modifieddate: "",
  //SOME OTHER FIELDS
  vendorname: "",
  typecode: "",
  workgroup: "",
  location: "",
  tcstatus: "",
  underwaranty: "",
  purchaseorderno: "",
  userlocationid: "",
};

const testingCommisionaReducer = (state = initialState, action) => {
  switch (action.type) {
    case testingCommisionaAtionTypes.SET_TC_FIELD_VALUES:
      return {
        ...state,
        ...action.payload
      };
    case testingCommisionaAtionTypes.RESET_TC_FIELD_VALUES:
      return initialState;

    default:
      return state;
  }
};


export default testingCommisionaReducer;